import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import InputLabel from '@mui/material/InputLabel';
import { makeStyles } from '@mui/styles';
import Checkbox from '../Checkbox/Checkbox';

const useStyles = makeStyles((theme) => ({
	chips: {
		display: 'flex',
		flexWrap: 'wrap',
	},
	chip: {
		margin: theme.spacing(0.25),
	},
}));

const SelectField = (props) => {
	const { id, name, value, error = false, onChange, hintText, menuItems, isMultiSelect = false, customRenderValue, formControlStyle, ...rest } = props;
	const classes = useStyles();
	const [labelWidth, setLabelWidth] = useState(0);
	const InputLabelRef = useRef(undefined);
	useEffect(() => {
		setLabelWidth(InputLabelRef.current ? InputLabelRef.current.offsetWidth : 0);
	}, []);

	// Validar valor para evitar out-of-range
	const validValue = isMultiSelect
		? (Array.isArray(value) ? value.filter(val => menuItems.some(item => item.value === val)) : [])
		: (menuItems.some(item => item.value === value) ? value : '');

	return (
		<FormControl error={!!error} fullWidth style={formControlStyle}>
			<InputLabel
				ref={ref => {
					InputLabelRef.current = ref;
				}}
				htmlFor={`${hintText}_selectField_input_id`}
			>
				{hintText}
			</InputLabel>
			<Select
				id={id}
				value={validValue}
				onChange={onChange}
				label={hintText}
				multiple={isMultiSelect}
				inputProps={{
					name,
					id: `${hintText}_selectField_input_id`,
				}}
				renderValue={isMultiSelect
					? (selected) => {
						if (customRenderValue) {
							return customRenderValue(selected, menuItems);
						}
						const selectedText = menuItems.filter(item => selected.indexOf(item.value) !== -1);
						return selectedText.map(item => item.text).join(', ');
					}
					: undefined
				}
				{...rest}
			>
				{!isMultiSelect && menuItems.map((item, i) => (
					<MenuItem id={item.value} key={i} value={item.value} disabled={item.disabled}>
						{item.text}
					</MenuItem>
				))}
				{isMultiSelect && menuItems.map((item, i) => (
					<MenuItem id={item.value} key={i} value={item.value} disabled={item.disabled}>
						<Checkbox checked={validValue.indexOf(item.value) > -1} />
						{item.text}
					</MenuItem>
				))}
			</Select>
			{error && <FormHelperText>{error}</FormHelperText>}
		</FormControl>
	);
};

SelectField.propTypes = {
	id: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.number,
		PropTypes.array
	]),
	name: PropTypes.string,
	error: PropTypes.any,
	onChange: PropTypes.func,
	hintText: PropTypes.string,
	menuItems: PropTypes.array,
	classes: PropTypes.object,
	isMultiSelect: PropTypes.bool,
	customRenderValue: PropTypes.func,
	formControlStyle: PropTypes.object
};

export default SelectField;
